export const BoardScope = Object.freeze({
  Global: "global",
  ProductVariant: "productvariant",
});

export const BoardStatus = Object.freeze({
  Active: "active",
  Inactive: "inactive",
});

// Flip to `true` to re-enable @-mention typeahead across every forum composer.
// Existing mention pills in saved bodies render regardless — this gates new mentions only.
export const MENTIONS_ENABLED = false;

// Mirrors backend InteractionsService.MaxReplyDepth. Top-level comment = 0,
// reply = 1, reply-of-reply = 2 (max). The inline "Reply" button is hidden
// once a comment reaches this depth so users can't compose a reply the
// backend would reject. Bump in lockstep with the backend constant if the
// product ever raises the cap.
export const MAX_REPLY_DEPTH = 2;

// Deterministic avatar palette — same author gets the same color across surfaces
// via (createdBy + first-letter charcode) % length.
export const AVATAR_COLORS = Object.freeze([
  "#1e88e5", "#43a047", "#e53935", "#8e24aa", "#fb8c00",
  "#00897b", "#5e35b1", "#6d4c41", "#d81b60", "#546e7a",
]);
